module.exports = __webpack_public_path__ + "static/media/Pin_Job_Winch.d560c45d.svg";